import { Link } from "@remix-run/react";
import { DollarSign, MapPinned, User, Users } from "lucide-react";
import { OhButton } from "~/components/ui/custom-radix-components/button";
import { getFormattedCountryName } from "~/lib/helpers/constants";
import { formatNumberToShortForm, getCurrentCustomerCount } from "~/lib/helpers/StringHelper";

export default function OfficeSearchAndPartnerSectionMobile({ region, className, searchUrl }: { region: string, className: string, searchUrl: string }) {
    let count = getCurrentCustomerCount({ isFormatted: false });
    count = formatNumberToShortForm(count);

    return (
        <section className={`px-2 py-4 flex flex-col md:flex-row gap-6 ${className || ''}`}>
            {/* Office Search Section */}
            <div className="p-4 flex flex-col gap-2">
                <h2 className="uppercase font-semibold text-xs md:text-sm text-gray-500 tracking-widest">Office Search</h2>
                <p className="text-2xl font-semibold text-gray-900">Exclusive Office Offers from Our Trusted Partners</p>
                <img
                    src={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/about-us-side-image.avif`}
                    alt="Office workspace video thumbnail showing modern office interior"
                    className="w-full  object-cover"
                />

                <p className="text-gray-600 text-sm">
                    Access premium workspaces across {getFormattedCountryName(region)} through our trusted partner network. We’ve teamed up with leading coworking and serviced office providers to bring you verified spaces, flexible lease options, exclusive discounts, and unbeatable pricing—all in one place.
                </p>
                <p className="text-gray-600 text-sm">
                    From flexible coworking desks to entire serviced floors, our {getFormattedCountryName(region)} team is here to help you find and secure the perfect space with ease. <b>Best of all our legendary service is totally free for tenants to find space.</b>
                </p>
                <ul className="space-y-2 py-3">
                    <li className="flex items-center gap-3 text-gray-600">
                        <MapPinned size={20} className="text-gray-500 flex-shrink-0" />
                        <span>{formatNumberToShortForm(35000)} workspace locations worldwide (110 countries)</span>
                    </li>
                    <li className="flex items-center gap-3 text-gray-600">
                        <User size={20} className="text-gray-500 flex-shrink-0" />
                        <span>Personalized guidance from our expert team</span>
                    </li>
                    <li className="flex items-center gap-3 text-gray-600">
                        <DollarSign size={20} className="text-gray-500 flex-shrink-0" />
                        <span>We guarantee the best price, every time</span>
                    </li>
                    <li className="flex items-center gap-3 text-gray-600">
                        <Users size={20} className="text-gray-500 flex-shrink-0" />
                        <span>Over {count} clients served since 2013</span>
                    </li>
                </ul>
                <Link to={searchUrl} target="_blank" >
                    <OhButton
                        className=" font-medium py-2 px-6 rounded-md w-full mt-2"
                    >
                        Search Office Space
                    </OhButton>
                </Link>

            </div>
        </section>
    );
} 